const EFAS_URLS = [
    "www.efas.local",
    "dev.efas.eu",
    "stage.efas.eu",
    "european-flood.emergency.copernicus.eu",
]

const IS_EFAS = EFAS_URLS.includes(window.location.hostname);
export default IS_EFAS;

export const IS_CANARY = window.location.hostname === 'canary.globalfloods.eu';
export const SMALL_DISPLAY = window.outerWidth < 600;
